module.exports = __webpack_public_path__ + "img/img-flow-2.f6ad5d37.jpg";